import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Device identity + client type for server-side license/device enforcement
export function deviceId() {
  let id = localStorage.getItem("strusst_device");
  if (!id) { id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`); localStorage.setItem("strusst_device", id); }
  return id;
}
api.defaults.headers.common["X-Device-Id"] = deviceId();
api.defaults.headers.common["X-Client-Type"] = /Android|iPhone|iPad|Mobile/i.test(navigator.userAgent) ? "mobile" : "desktop";
export async function downloadPdf(url, filename) {
  const r = await api.get(url, { responseType: "blob" });
  const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 10000);
}

let _graceToastAt = 0;
api.interceptors.response.use(r => r, (err) => {
  const code = err.response?.data?.code;
  if (code === "GRACE_READ_ONLY") {
    if (Date.now() - _graceToastAt > 4000) { _graceToastAt = Date.now(); import("sonner").then(({ toast }) => toast.error("Read-only grace period", { description: err.response.data.detail, action: { label: "Recharge", onClick: () => window.location.assign("/subscription") } })); }
    return Promise.reject(err);
  }
  if (code && ["SUBSCRIPTION_EXPIRED", "ACCOUNT_SUSPENDED", "ACCOUNT_BLOCKED", "DEVICE_LIMIT", "DEVICE_BLOCKED", "CLIENT_TYPE_BLOCKED", "SERVICE_DISABLED", "SESSION_REVOKED"].includes(code) && !window.location.pathname.startsWith("/subscription")) {
    sessionStorage.setItem("strusst_license_block", JSON.stringify(err.response.data));
    if (code !== "SERVICE_DISABLED") window.location.assign("/subscription");
  }
  return Promise.reject(err);
});

// Also add Bearer token fallback for environments where third-party
// cookies aren't sent by the browser.
export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("strusst_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("strusst_token");
  }
}

const stored = typeof window !== "undefined" ? localStorage.getItem("strusst_token") : null;
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
